module.exports = __webpack_public_path__ + "static/media/team-img4.bc567755.jpg";